export const MARKER_SIZE = 20

export const PADDING = 100

export const DEFAULT_WIDTH = 600

export const DEFAULT_HEIGHT = 400

export const DEFAULT_ZOOM = 18

export const DEFAULT_DURATION = 1000

export const MERINIO_INITIAL_MAP_VIEW_SETTINGS = {
  longitude: -73.62054376278073,
  latitude: 45.532898720734494,
  zoom: 17.5
}
